
import Vue, { VNode } from 'vue'

export default Vue.extend({
  name: 'ItemListingElement',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    getTableDatasFromChildren(h: Function): VNode[] {
      const defaultSlot = this.$slots.default

      if (!defaultSlot || !defaultSlot.length) return []

      const letsRenderThis: VNode[] = []

      Object.values(defaultSlot).forEach((Vnode: VNode) => {
        // when element is removed from the (V)DOM, it looses a tag
        // the wrappers are useful as long the node within
        const shouldWrap = Vnode.tag

        const wrap = (node: VNode) => h('td', { class: ['ok'] }, [node])

        let pushedNode = shouldWrap ? wrap(Vnode) : Vnode

        letsRenderThis.push(pushedNode)
      })

      return letsRenderThis
    },
    handleClick(): void {
      if (this.disabled) return
      this.$emit('click')
    },
    handleDoubleClick(): void {
      if (this.disabled) return
      this.$emit('dblclick')
    },
  },

  computed: {
    classes(): { [key: string]: boolean } {
      const { selected, disabled } = this
      const classObj = {
        'item-listing-element': true,
        disabled,
        selected,
      }

      return classObj
    },
  },

  render(h): VNode {
    return h(
      'tr',
      {
        class: this.classes,
        on: { click: this.handleClick, dblclick: this.handleDoubleClick },
      },
      [...this.getTableDatasFromChildren(h)],
    )
  },
})
